import Homepage from './Homepage';

export const homepageRoutes = [{path: '/', name: 'Homepage', Component: Homepage, exact: false}];
